import React, { Component } from 'react';
import Responsive from "./Responsive/index";
import ResponsiveV2 from './ResponsiveV2'
import { connect } from 'react-redux';
import CustomScrollbars from "util/CustomScrollbars";
import {getThisUserInterface} from 'actions'

const mapStateToProps = ({ auth, accountsData,Dashboard }) => {
    return {
        authUser: auth.authUser,
        token: auth.token,
        CurrentUser: auth.user,
        message: auth.message,
        LobbySetting: accountsData.LobbySetting,
    }
}

class Intranet extends Component {
   
    render() {
        console.log(this.props.LobbySetting.AnpassadLobby,'this.props INDEX2 CHECK')
        const { userid, idFromAdmin} = this.props.match.params;
        // height: 'calc(100% - 40px)'
        const { user_Afid, user_Email, user_Notification, user_SeeCasesList, user_SeeContractFlag, user_SeeDialer, user_SeeEndClients, user_SeeOrderList, user_SeeRinglist, user_WeekNotification, user_fnamn, user_id, user_lnamn, user_role } = this.props.authUser;
        return (
            <>
            {
                parseInt(this.props.LobbySetting.AnpassadLobby) === 0?
                <CustomScrollbars style={{background:"#f4f4f4", height: 'calc(100%)'}}>
                    <div>
                        <div className="p-sm-0 px-lg-4">
                            <Responsive authUser={this.props.authUser} Dashboard={this.props.Dashboard} />
                        </div>
                    </div>
                </CustomScrollbars>
                :
                <CustomScrollbars style={{background:"#f4f4f4", height: 'calc(100%)'}}>
                    <div>
                        <div className="p-sm-0 px-lg-4">
                            <ResponsiveV2 authUser={this.props.authUser} />
                        </div>
                    </div>
                </CustomScrollbars>
            }
            </>
        )
    }
}

export default connect(mapStateToProps,{getThisUserInterface})(Intranet)